module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAATklEQVQ4y2P4jwQ+MAww7wADDNgPCh7YXYOCxwwOIIbBwOP/A3TZB+b/g4HHAGL8/8MwGHj8wECCCA08D8Rg4Ed25wDyBjoXI3iDp6wDAN4I3DEboPPgAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI3OjA5KzA5OjAwtvXhfwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00036_100x100.png
// module id = yGts
// module chunks = 0